import Title from './Title';
import Content from './Content';

export default {
  Title,
  Content,
};
